import axios from "axios";
import { appConstants } from "./appConstants";
import { AUTH_SESSION_KEY, createAuthSession } from "./authSession";

const session = createAuthSession({
  persistent: window.localStorage,
  tab: window.sessionStorage,
  onChange: ({ reload }) => {
    if (reload) window.location.reload();
  },
});
session.initialize();
window.addEventListener("storage", (event) => {
  if (
    event.storageArea === window.localStorage &&
    (event.key === AUTH_SESSION_KEY || event.key === null)
  )
    session.synchronize();
});
// Includes legacy API modules which captured an Authorization header at import.
// Never attach the login token to third-party URLs.
axios.interceptors.request.use((config) => {
  const destination = new URL(
    config.url || "",
    config.baseURL || window.location.origin
  );
  const api = new URL(appConstants.baseURL, window.location.origin);
  if (
    destination.origin === api.origin &&
    destination.pathname.startsWith(
      api.pathname.endsWith("/") ? api.pathname : api.pathname + "/"
    )
  ) {
    config.headers = config.headers || {};
    delete config.headers.authorization;
    const token = window.sessionStorage.getItem("TOKEN");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    else delete config.headers.Authorization;
  }
  return config;
});
